var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sv"},[_c('h1',{staticClass:"sv-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"sv-v"}),_c('div',{staticClass:"sv-box"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }